import { render, staticRenderFns } from "./NewLKL.vue?vue&type=template&id=44d48e3f&scoped=true&"
import script from "./NewLKL.vue?vue&type=script&lang=js&"
export * from "./NewLKL.vue?vue&type=script&lang=js&"
import style0 from "./NewLKL.vue?vue&type=style&index=0&id=44d48e3f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d48e3f",
  null
  
)

export default component.exports